export class AccessGroupModel{
    id: number;
    name: string;
}
